import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AboutComponent } from 'src/app/view/about/about.component';
import { ChairmanComponent } from 'src/app/view/about/chairman/chairman.component';
import { OvrviewComponent } from 'src/app/view/about/ovrview/ovrview.component';
import { PrincipalComponent } from 'src/app/view/about/principal/principal.component';
import { VicePrincipalComponent } from 'src/app/view/about/vice-principal/vice-principal.component';
import { VisionComponent } from 'src/app/view/about/vision/vision.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';



@NgModule({
  declarations: [
    AboutComponent,
    OvrviewComponent,
    VicePrincipalComponent,
    PrincipalComponent,
    ChairmanComponent,
    VisionComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {path:'',component:AboutComponent,children:[
        {path:'overview',component:OvrviewComponent},
        {path:'vice-principal',component:VicePrincipalComponent},
        {path:'principal',component:PrincipalComponent},
        {path:'chairman',component:ChairmanComponent},
        {path:'vision',component:VisionComponent}
      ]}
    ]),
    SharedModule
  ]
})
export class AboutModule { }
